// Learn Creole locale shim.
//
// The Learn Creole string set originated on web (EN-only) and was
// ported to the native mobile apps, which then added HT + FR + ES
// translations. As of hat-labs-core commit b41692bd (2026-08-22) the
// shared bundle at hat-labs-core/locales/*.json was renamed from
// `mobile.learning.*` to top-level `learning.*` — the `mobile.`
// prefix reflected historical order, not ownership. Web is (and
// remains) the source of truth for Learn Creole strings.
//
// Web exposes all 4 languages (EN, HT, FR, ES) — same coverage as
// mobile. HT chrome IS a valid UX (a Creole speaker using the app
// to reinforce/teach others; app frame in HT even though target
// vocabulary is English/French/Spanish per-lesson).
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const LEARNING_COPY = {
  en: en.learning,
  ht: ht.learning,
  fr: fr.learning,
  es: es.learning,
  'pt-BR': ptBR.learning,
  'zh-Hans': zhHans.learning,
}

export default LEARNING_COPY
